import type { RuleSet } from 'styled-components';
import styled, { css } from 'styled-components';
import { Show } from '@elfsight/lib-utils';
import { createReadableClass } from '@elfsight/widget-utils';
import { Fade } from './fade';
import { Flip } from './flip';
import { Slide } from './slide';

type Animation = 'none' | 'flip' | 'slide' | 'fade';

export type AnimatedContainerProps = {
  children: string;
  animation: Animation;
  accentColor: string;
  className?: string;
};

export function AnimatedContainer({
  children,
  animation,
  accentColor,
  className
}: AnimatedContainerProps) {
  return (
    <Container _animation={animation} className={className}>
      <Show when={animation === 'none'}>{children}</Show>

      <Show when={animation === 'fade'}>
        <Fade>{children}</Fade>
      </Show>

      <Show when={animation === 'slide'}>
        <Slide>{children}</Slide>
      </Show>

      <Show when={animation === 'flip'}>
        <Flip accentColor={accentColor}>{children}</Flip>
      </Show>
    </Container>
  );
}

const slideStyles = css`
  overflow: hidden;
`;

const flipStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  perspective: 3.2em;
`;

const stylesMapping: Record<Animation, RuleSet> = {
  none: css``,
  fade: css``,
  slide: slideStyles,
  flip: flipStyles
};

const Container = styled.div.attrs<{ _animation: Animation }>(
  ({ _animation }) => ({
    className: createReadableClass({
      component: 'animated-container',
      index: _animation
    })
  })
)`
  ${({ _animation }) => stylesMapping[_animation]};
`;
